<div class="pay-amount">
  <ng-container
    i18n="Money amount caption|“Card details” section of the checkout flow, and is followed by the grand total amount."
    >Charge</ng-container
  >:
  <span>{{ amount | appCurrency: symbol }}</span>
</div>

<div class="pay-text text-center">
  <ng-container
    i18n="Payment call-to-action text|“Card details” section of the checkout flow, just above the card field."
    >You can pay using your card</ng-container
  >
</div>

<form #checkout="ngForm" (ngSubmit)="sendRequest()" class="checkout">
  <div class="form-row">
    <div id="card-info" #cardInfo></div>
    <div id="card-errors" class="mat-error text-center w-100" role="alert" *ngIf="error">{{ error }}</div>
  </div>

  <button [disabled]="processingForm" class="form-submit" type="submit" test-id="pay-button">
    <ng-container
      i18n="Caption on the button to submit payment|“Card details” section of the checkout flow, below the card field."
      >Submit Payment</ng-container
    >
    <mat-spinner *ngIf="processingForm" mode="indeterminate" diameter="20"></mat-spinner>
  </button>
</form>
